import axios from 'axios'

const dev = location?.origin?.includes('dev-io') ? 'dev-' : ''
const PRESENTATION_HOST =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : `https://${dev}io.winwinapp.ru`
const MINORS_HOST =
  process.env.NODE_ENV === 'development'
    ? `http://localhost:3055`
    : `https://${dev}minors.winwinapp.ru`

export default {
  sendFeedback(props) {
    const { domain, body, pId } = props

    return axios
      .post(`${PRESENTATION_HOST}/presentation/${domain}/feedback/add`, body, {
        params: {
          pId,
        },
      })
      .then((res) => {
        console.log(res.data?.data)
      })
  },
  getMapInfrastructure(bounds) {
    const [lat, lng] = bounds

    return axios
      .get(`${PRESENTATION_HOST}/map`, {
        params: {
          bbox: `${lat[1]},${lat[0]}~${lng[1]},${lng[0]}`,
        },
      })
      .then((res) => res.data.response)
      .catch(console.error)
  },
  getHidingFieldsConfig(domain) {
    return axios
      .get(`${MINORS_HOST}/settings/field/${domain}`)
      .then((res) => res.data)
      .catch((e) => {
        console.error(e)
        return {}
      })
  },
  getCurrencyDict() {
    return axios
      .get(`https://minors.winwinapp.ru/static/currencyDict.json`)
      .then((res) => res.data)
      .catch((e) => {
        console.error(e)
        return {}
      })
  },
  getPresentationLocale({ domain, localeId }) {
    const defaultLocale = {
      presentation: {
        constants: [],
      },
      general: [],
    }
    return axios
      .get(`${MINORS_HOST}/settings/local/${domain}/${localeId}`)
      .then((res) => res.data.data || defaultLocale)
      .catch((e) => {
        console.error(e)
        return defaultLocale
      })
  },
  getPresentation({ domain, managerId, pId, ids }) {
    return axios
      .get(`/api/${domain}/${managerId}`, {
        params: {
          pId,
          ids,
        },
      })
      .then((res) => res.data.data)
  },
}
